import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardText,
  MDBCardTitle,

}
from 'mdb-react-ui-kit';
import '../../css/index.css';
function HomeResponsavel(props) {
  const navigate = useNavigate();
  return (
    <div className="d-flex justify-content-center align-items-center" style={{height:'80vh'}}>
      <MDBCard className='bg-dark w-100 d-flex justify-content-center align-items-center p-5' style={{minWidth:'250px'}}>
        <MDBCardBody className='bg-dark w-100'>
          <MDBCardTitle className='text-white'>Bem vindo, {props.nomeres}</MDBCardTitle>
          <MDBCardText className='text-white'>
            O que veio fazer?
          </MDBCardText>
          <div className="d-grid gap-1 w-100">
          <MDBBtn 
              className='btn-home w-100'
              size='lg'
              outline 
              color='white' 
              onClick={() => navigate("/area-checkin")}
              >Area do checkin</MDBBtn>
          </div>
        </MDBCardBody>

      </MDBCard>
    </div>
  );
}

export default HomeResponsavel;